import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-state',
  templateUrl: './error-state.component.html',
  styleUrls: ['./error-state.component.scss'],
})
export class ErrorStateComponent implements OnInit {
  ngOnInit(): void {
    window.localStorage.clear();
  }
}
